import { Component, OnInit, OnDestroy, TemplateRef, ViewContainerRef, AfterViewInit } from '@angular/core';
import { ManageService } from '../../../services/manage.service';
import { CommonService } from '../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TransitionEligibility } from '../../../models/transitionEligibility.mode';
import { CancelContent, CSPModifySubscriptionViewModel, GetCSPSubscription, MCEUpgradeModel, ProductTerm, RefundableDetails, RefundableQuantity, ScheduledNextTermInstructions, CSPModifySubscriptionResponse, CSPSubscriptions, SupportedBillingCycle } from '../../../models/csp.model';
import { MatDialog } from '@angular/material/dialog';
import { PanelService } from '../../../services/panel.service';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { CalculateRIReturnPopupComponent } from '../../../popup-collection/calculate-ri-return-popup/calculate-ri-return-popup.component';

@Component({
  selector: 'app-manage-reserved-instance',
  templateUrl: './manage-reserved-instance.component.html',
  styleUrls: ['./manage-reserved-instance.component.css'],
  providers: [DatePipe]
})
export class ManageReservedInstanceComponent implements OnInit, OnDestroy, AfterViewInit {

  loadContent = false;
  tenantId: string;
  subscriptionId: string;
  searchUpgrade: string;
  offerId: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  title = 'Manage Reserved Insatance';
  transitionEligibilities: TransitionEligibility[] = [];
  transitionEligibilitiesFilters: TransitionEligibility[] = [];
  mpnList: string[] = [];
  NoMPNText = '';
  from: GetCSPSubscription = {} as GetCSPSubscription;
  stockCode: string[] = [];
  billingFrequencyList: SupportedBillingCycle[];
  billingCycle: string;
  termDuration: string;

  // loading flag group
  autoRenewLoading = false;
  renewalLoading = false;
  billingLoading = false;
  qtyLoading = false;
  customEndDateLoading = false;

  isBillingFreq: boolean = true;

  constructor(
    private manageService: ManageService,
    public commonService: CommonService,
    private router: Router,
    public sidenavService: PanelService,
    public calendar: NgbCalendar,
    private dialog: MatDialog
  ) {
  }

  async ngAfterViewInit() {
    await this.commonService.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
  }

  calculate() {
    this.dialog.open(CalculateRIReturnPopupComponent, {
      width: '400px',
      data: {
        title: 'Culculate Return',
        msg: 'the return is: $3432423',
        buttonName: 'Return',
        showCancel: true
      }
    })
  }

  ngOnInit() {
    this.manageService.currentReservedInstance
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(val => {
        console.log(val)
        // if (!isEmpty(val)) {
        //   this.checkingSoftwareSubscriptionIndex = -1;
        //   this.router.navigate(['ManageLicenseSubscriotion/SubscriptionDetails/', { sof: val.subscription.stockCode }], { relativeTo: this.activatedRoute });
        //   this.manageService.sendCurrentSoftwareSubscription(val);
        // } else {
        //   this.commonService.implementToast("No options available to manage this reserved instance subscription!", "Warning");
        //   this.checkingSoftwareSubscriptionIndex = -1;
        // }
      });
  }

  close() {
    this.manageService.monitorCurrentCSPReservedInstance(null);
    this.manageService.backToTenentPage(this.tenantId);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    if (this.sidenavService?.panel?.opened) {
      this.sidenavService.panel.close()
    }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
